import {
  CREATE_EVENT_RULE_WITH_USER_IDS,
  CREATE_EVENT_RULE_WITH_USER_IDS_SUCCESS,
  CREATE_EVENT_RULE_WITH_USER_IDS_ERROR,
  CREATE_EVENT_RULE_WITH_USER_IDS_EMPTY,
} from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateEventRulesWithUserIds = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EVENT_RULE_WITH_USER_IDS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_EVENT_RULE_WITH_USER_IDS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_EVENT_RULE_WITH_USER_IDS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_EVENT_RULE_WITH_USER_IDS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateEventRulesWithUserIds;
